import { Maybe } from '../interface'

export function value<T>(value: Maybe<T> | undefined, defaultValue: T) {
  if (!value) {
    return defaultValue
  }
  return value
}
export function values<T>(value: Maybe<Maybe<T>[]> | undefined, defaultValue: T[] = []) {
  if (!value) {
    return defaultValue
  }
  return value.filter((v): v is T => !!v)
}
